import React from 'react';

function HeroActivity() {
  return (
    <div>
      <div>
        <div className="hero__activity">
          <div className="container">
            <div className="space-y-10">
              <h1 className="text-center">Activity Feed</h1>
              <p className="hero__desc text-center">
                A peer-to-peer marketplace for NFTs, rare digital items and
                crypto collectibles. Buy, sell, auction, and discover
                CryptoKitties, Decentraland, ...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroActivity;
